import { Modal } from "antd"
import React from "react"

const ErrorModal = ({ uploadErrors = [], open, onCancel, uploadMessage }) => {
  return (
    <div>
      <Modal
        title={
          <span style={{ color: "#cf2e2e", fontWeight: "bold" }}>
            Danh sách lỗi khi tải lên
          </span>
        }
        open={open}
        onCancel={onCancel}
        footer={null}
        width={600}
      >
        <div style={{ marginBottom: 12, fontSize: 15, color: "#333" }}>
          {uploadMessage ||
            "Một số dòng trong file không hợp lệ. Vui lòng kiểm tra:"}
        </div>

        <div
          style={{
            maxHeight: 300,
            overflowY: "auto",
            border: "1px solid #f0f0f0",
            borderRadius: 6,
            padding: 12,
            background: "#fffbe6",
          }}
        >
          {uploadErrors?.map((err, idx) => (
            <p key={idx} style={{ color: "#d32029", marginBottom: 8 }}>
              {err}
            </p>
          ))}
        </div>

        <div style={{ textAlign: "right", marginTop: 16 }}>
          <button
            onClick={() => onCancel()}
            style={{
              padding: "6px 16px",
              backgroundColor: "#d32029",
              color: "#fff",
              border: "none",
              borderRadius: 4,
              cursor: "pointer",
            }}
          >
            Đóng
          </button>
        </div>
      </Modal>
    </div>
  )
}

export default ErrorModal
